import React from 'react';
import { NotesRequiringApprovalDetails } from 'MessageCenter/NotesRequiringApproval';
import { NotesPendingActionDetails } from 'MessageCenter/NotesPendingAction';
// import { PeerReviewWorkCompDetails } from 'MessageCenter/PeerReview/WorkComp';
import { PeerReviewFederalDetails } from 'MessageCenter/PeerReview/Federal';
import { PeerReviewSpecialProgDetails } from 'MessageCenter/PeerReview/SpecialProg';
import { ProgressDueDetails } from 'MessageCenter/ProgressDue';
import { DischargeDueDetails } from 'MessageCenter/DischargeDue';
import { DiaryTasksDetails } from 'MessageCenter/DiaryTasks';
import { MCCategories, MCCategoryIds } from '_constants'


export class MessageDetails extends React.Component {
    render() {
        switch (this.props.selectedCategory) {
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.NOTES_REQUIRING_APPROVAL)].id:
                return (<NotesRequiringApprovalDetails />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.NOTES_PENDING_ACTION)].id:
                return (<NotesPendingActionDetails />);
            // case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.PEER_REVIEW_WC)].id:
            //     return (<PeerReviewWorkCompDetails />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.PEER_REVIEW_FEDERAL)].id:
                return (<PeerReviewFederalDetails />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.PEER_REVIEW_SPECIAL_PROG)].id:
                return (<PeerReviewSpecialProgDetails />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.PROGRESS_DUE)].id:
                return (<ProgressDueDetails />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.DISCHARGE_DUE)].id:
                return (<DischargeDueDetails />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.DIARY_TASKS)].id:
                return (<DiaryTasksDetails />);
            default:
                return (<NotesPendingActionDetails />);
        }
    }
}


